import {flatMap, catchError} from 'rxjs/operators';
import {ofType} from 'redux-observable';
import {of} from 'rxjs';
import i18next from 'i18next';

import {combineEpics} from 'web-app/util/redux-observable';
import * as GlobalEventActions from 'web-app/react/global-event/actions';

import * as api from './api';
import * as Actions from './actions';

const confirmEmailObservable = (token: string) =>
    api
        .confirmEmail(token)
        .pipe(
            flatMap(() => [
                Actions.confirmEmailSuccess.action(),
                GlobalEventActions.updateSuccess.action(i18next.t('login.emailChangeVerified')),
            ]),
        );

const confirmEmail = action$ =>
    action$.pipe(
        ofType(Actions.confirmEmail.type),
        flatMap(({payload}: ReturnType<typeof Actions.confirmEmail.action>) => confirmEmailObservable(payload.token)),
        catchError(error => of(Actions.confirmEmailFailed.action(error))),
    );

export default combineEpics(confirmEmail);
